import { provideTanStackQuery, QueryClient } from "@tanstack/angular-query-experimental";
import { withDevtools } from "@tanstack/angular-query-experimental/devtools/production";
import { provideEnvironmentInitializer, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { doc, Timestamp } from "firebase/firestore";
import { FIRESTORE, docData } from "@dis/firebase";
import { SheetsMetadataService } from "@dis/shared";
import { SSID } from "@dis/models";
import { DevtoolsOptionsManager } from "../services/tanstack.devtools";
import * as Sentry from "@sentry/angular";

export function provideTanstack(environment: any) {
  const queryClient = new QueryClient();

  return [
    provideTanStackQuery(
      queryClient,
      withDevtools(
        (devToolsOptionsManager: DevtoolsOptionsManager) => ({
          loadDevtools: devToolsOptionsManager.loadDevtools(),
        }),
        {
          deps: [DevtoolsOptionsManager],
        }
      )
    ),
    provideEnvironmentInitializer(() => {
      const snackbar = inject(MatSnackBar);
      const realtime = inject(SheetsMetadataService);
      queryClient.setMutationDefaults([], {
        onSuccess: async (data, variables, onMutateResult, context) => {
          const mutationKey = context?.mutationKey?.toString();
          console.info("✅ Global mutation success handler:", {
            data,
            variables,
            onMutateResult,
            context,
            mutationKey,
          });
          await realtime.updateSheetMetadata(SSID.DATACONNECT, {}, mutationKey);
          snackbar.open(
            `✅ ${context?.mutationKey?.[0]?.toString()?.toUpperCase()} Success` || "Operation successful",
            "Close",
            {
              duration: 3000,
            }
          );
        },
        onSettled: async (data, error, variables, context) => {
          console.info("ℹ️ Global mutation settled handler:", { data, error, variables, context });
          // await realtime.updateSheetMetadata(SSID.DATACONNECT, {}, Object.keys(data)[0]?.toString());
        },
        onError: (error: unknown, variables, onMutateResult, context) => {
          console.error("❌ Global mutation error handler:", error);
          Sentry.captureException(error, { extra: { variables, onMutateResult, mutationKey: context?.mutationKey } });
          snackbar.open(`❌ Global mutation error handler:: ${error}`, "Close");
        },
      });
    }),
    provideEnvironmentInitializer(() => {
      const firestore = inject(FIRESTORE);
      docData(doc(firestore, "sheets-metadata/dataconnect")).subscribe(
        (metadata) => {
          console.log("📄 Dataconnect sheet metadata updated:", metadata);
          if (!metadata) {
            return;
          }
          const { mutationKey, updatedAt } = metadata as { mutationKey: string; updatedAt: Timestamp };
          console.log("♻️ Invalidating queries with mutationKey:", mutationKey);
          queryClient.invalidateQueries({
            predicate: (query) => {
              return mutationKey.split(",").some((key) => {
                return new RegExp(key.trim(), "i").test(JSON.stringify(query.queryKey));
              });
            },
          });
        }
      );
    }),
  ];
}
